'use client'
import { usePathname } from 'next/navigation'
import { useGraphql } from '@dustin-web/microsite-data/src/hooks'
import { NotificationBanner, NotificationTypes } from '@dustin-web/microsite-components/src/banners'
import { GET_NOTIFICATION_BANNER_RESULT } from '@dustin-web/microsite-data/src/graphql/content/get-notification-banner.graphql'
import { GetNotificationBannerResultQuery } from '@dustin-web/microsite-data/src/graphql/content/generated/graphql-types'
import isPublicConvertedDate from '../utils'
import { isPathMatch } from '../utils/path-match'

const NotificationBannerContainer = () => {
  const pageUri = usePathname()

  const { data } = useGraphql<GetNotificationBannerResultQuery>(GET_NOTIFICATION_BANNER_RESULT)
  const { notificationbanner } = data ?? {}

  if (!notificationbanner) {
    return
  }

  const {
    notificationDisplayEverywhere,
    notificationDisplayUrls,
    notificationPublished,
    notificationUnpublished,
    notificationButtonText,
    notificationButtonUrl,
    notificationType,
    notificationTitle,
    notificationDescription,
    notificationContentList,
    notificationPrimaryButton,
  } = notificationbanner

  if (
    (!notificationDisplayEverywhere && !isPathMatch(notificationDisplayUrls, pageUri)) ||
    !isPublicConvertedDate(notificationPublished || '', notificationUnpublished || '')
  ) {
    return
  }

  const ctaButtonEnabled = notificationButtonText && notificationButtonUrl

  return (
    <NotificationBanner
      customIcon={notificationType === NotificationTypes.WARNING ? 'sad-dislike-face' : undefined}
      type={(notificationType as `${NotificationTypes}`) || NotificationTypes.INFO}
      closeable
      fullWidth
      title={notificationTitle}
      description={notificationDescription}
      list={notificationContentList}
      ctaButton={!!ctaButtonEnabled}
      href={notificationButtonUrl}
      buttonText={notificationButtonText}
      primaryButton={notificationPrimaryButton}
    />
  )
}

export default NotificationBannerContainer
